import React from 'react'

import { StyledTableCell, StyledTableRow } from '../../../components/EnchancedTable'
import { AuthLogEntry } from '../../../types'
import moment from 'moment'

interface Props {
  entry: AuthLogEntry
}

const AuthLogRow: React.FC<Props> = ({ entry }) => {
  return (
    <StyledTableRow hover role="checkbox" tabIndex={-1} key={entry.referenceId}>
      <StyledTableCell>{moment(entry.loginTime).format('YYYY-MM-DD HH:mm:ss Z')}</StyledTableCell>
      <StyledTableCell>{entry.username}</StyledTableCell>
      <StyledTableCell>{entry.email}</StyledTableCell>
      <StyledTableCell>{entry.application}</StyledTableCell>
    </StyledTableRow>
  )
}

export default AuthLogRow
